import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { RentalReportFilterModel } from 'src/app/models/rental/rental-report-filter.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RentalReportService {

  constructor(private _httpClient: HttpClient) { }

  exportRentalReportBalancesClientCostCenter(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ExportRentalReportBalancesClientCostCenter}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportRentalReportBalancesShop(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ExportRentalReportBalancesShop}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportRentalReportBalancesWorkshop(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ExportRentalReportBalancesWorkshop}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportRentalReportCostCenterDistribution(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ExportRentalReportCostCenterDistribution}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportRentalReportClientDistribution(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ExportRentalReportClientDistribution}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportRentalReportConstructionWithoutEquipment(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ExportRentalReportConstructionWithoutEquipment}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportRentalReportDaysConstructionSite(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ExportRentalReportDaysConstructionSite}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportRentalReportMovementsKilograms(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ExportRentalReportMovementsKilograms}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportRentalReportHistoricalMovementCostCenter(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ExportRentalReportHistoricalMovementCostCenter}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportRentalReportHistoricalMovementShop(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ExportRentalReportHistoricalMovementShop}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportRentalReportCostCenterDiscounts(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ExportRentalReportCostCenterDiscounts}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportRentalReportHistoricalMovementWorkshop(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ExportRentalReportHistoricalMovementWorkshop}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportReportInvoicedReplacement(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ExportRentalReportInvoicedReplacement}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportRentalReportOccupancyPercentage(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ExportRentalReportOccupancyPercentage}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportRentalReportSummaryBalances(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ExportRentalReportSummaryBalances}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportRentalReportReplacement(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ExportRentalReportReplacement}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportRentalReportTotalDistribution(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ExportRentalReportTotalDistribution}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportRentalReportTransport(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ExportRentalReportTransport}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  rentalReportBalancesClientCostcenter(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.BalancesClientCostcenter}`,
      rentalReportFilterModel);
  }

  rentalReportBalancesShop(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.BalancesShop}`,
      rentalReportFilterModel);
  }

  rentalReportBalancesWorkshop(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.BalancesWorkshop}`,
      rentalReportFilterModel);
  }

  rentalReportClientDistribution(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ClientDistributionModel}`,
      rentalReportFilterModel);
  }

  rentalReportConstructionWithoutEquipment(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ConstructionWithoutEquipmentModel}`,
      rentalReportFilterModel);
  }

  rentalReportCostCenterDistribution(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.CostCenterDistributionModel}`,
      rentalReportFilterModel);
  }

  rentalReportDaysConstructionSite(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.DaysConstructionSiteModel}`,
      rentalReportFilterModel);
  }

  rentalReportMovementsKilograms(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.MovementsKilograms}`,
      rentalReportFilterModel);
  }

  rentalReportHistoricalMovementCostCenter(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.HistoricalMovementCostCenter}`,
      rentalReportFilterModel);
  }

  rentalReportHistoricalMovementShop(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.HistoricalMovementShop}`,
      rentalReportFilterModel);
  }

  rentalReportCostCenterDiscounts(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.CostCenterDiscounts}`,
      rentalReportFilterModel);
  }

  rentalReportHistoricalMovementWorkshop(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.HistoricalMovementWorkshop}`,
      rentalReportFilterModel);
  }

  rentalReportInvoicedReplacement(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.InvoicedReplacement}`,
      rentalReportFilterModel);
  }

  rentalReportOccupancyPercentage(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.OccupancyPercentage}`,
      rentalReportFilterModel);
  }

  rentalReportReplacement(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.ReportReplacement}`,
      rentalReportFilterModel);
  }

  rentalReportSummaryBalances(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.SummaryBalances}`, rentalReportFilterModel);
  }

  rentalReportTotalDistribution(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.TotalDistributionModel}`,
      rentalReportFilterModel);
  }

  rentalReportTransport(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalReport.Transport}`,
      rentalReportFilterModel);
  }

}
